import React from 'react';

import CheckboxSquare from '@hero/ui-kit/graphics/CheckboxSquare';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';

import * as Style from './FilterOptionRow.module.scss';

export interface FilterOptionRowProps {
    label: React.ReactNode;
    selected: boolean;
    mode: 'multi' | 'single';
    onToggle: () => void;
    // Optional leading node (e.g. a status dot or avatar) after the control.
    leading?: React.ReactNode;
    // Optional trailing node (e.g. a count or alert icon), pinned to the right.
    trailing?: React.ReactNode;
    disabled?: boolean;
}

// One shared option row for every list-style filter (single or multi). Replaces
// the near-identical `.filterItem` markup that used to live in ListFilter,
// StatusFilter, DeviceFilter and DisengagedMembers.
const FilterOptionRow: React.FC<FilterOptionRowProps> = ({
    label,
    selected,
    mode,
    onToggle,
    leading,
    trailing,
    disabled = false
}) => {
    const className = [Style.row, selected && Style.selected, disabled && Style.disabled]
        .filter(Boolean)
        .join(' ');

    return (
        <ClickableOpacity
            fullWidth
            alt={typeof label === 'string' ? `Toggle ${label}` : 'Toggle filter'}
            className={className}
            onClick={onToggle}
        >
            <div className={Style.main}>
                {mode === 'multi' ? (
                    <CheckboxSquare
                        isChecked={selected}
                        isFocused={false}
                        isHovered={false}
                        disabled={disabled}
                        styles={{ minWidth: '1.9rem', height: '1.9rem', width: '1.9rem' }}
                    />
                ) : (
                    <span className={`${Style.radio} ${selected ? Style.radioActive : ''}`} />
                )}
                {leading}
                {typeof label === 'string' ? (
                    <P noDefaultMargin className={Style.label}>
                        {label}
                    </P>
                ) : (
                    label
                )}
            </div>
            {trailing ? <span className={Style.trailing}>{trailing}</span> : null}
        </ClickableOpacity>
    );
};

export default FilterOptionRow;
